import React, { useEffect, useState } from "react";
import useDataStore from "../../../stores/dataStore";
import Folder from "./folder/folder";
import useMainStore from "../../../stores/mainStore";

function FoldersContainer() {
    const folders = useDataStore((state) => state.data.folders);
    const [folderIDs, setFolderIDs] = useState<string[]>([]);
    const sortFoldersBy = useMainStore((state) => state.data.sortFoldersBy);
    const sortFoldersNewToOld = useMainStore(
        (state) => state.data.sortFoldersNewToOld
    );

    const filterString = useMainStore((state) => state.data.filterString);

    // Sort Folders
    useEffect(() => {
        let folderIDs: string[] = [];

        switch (sortFoldersBy) {
            case "Date Created":
                folderIDs.push(
                    ...Object.values(folders)
                        .sort(
                            (a, b) =>
                                new Date(a.createdAt).getTime() -
                                new Date(b.createdAt).getTime()
                        )
                        .map((folder) => folder.id)
                );

                break;
            case "Date Updated":
                folderIDs.push(
                    ...Object.values(folders)
                        .sort(
                            (a, b) =>
                                new Date(a.updatedAt).getTime() -
                                new Date(b.updatedAt).getTime()
                        )
                        .map((folder) => folder.id)
                );

                break;
            case "Title":
                folderIDs.push(
                    ...Object.values(folders)
                        .sort((a, b) => {
                            if (!a.name || !b.name) return 0;
                            return a.name.localeCompare(b.name);
                        })
                        .map((folder) => folder.id)
                );

                break;

            default:
                break;
        }

        if (filterString) {
            folderIDs = folderIDs.filter((id) => {
                if (
                    folders[id]?.name
                        .toLowerCase()
                        .includes(filterString.toLowerCase())
                )
                    return true;

                //? Eventually add text file filtering
            });
        }

        if (!sortFoldersNewToOld) {
            folderIDs.reverse();
        }
        setFolderIDs(folderIDs.filter((id) => folders[id]?.id));
    }, [folders, sortFoldersBy, sortFoldersNewToOld, filterString]);

    return (
        <div className="flex flex-1 flex-col py-[2px] ">
            <Folder />
            {folderIDs.map((id) => (
                <Folder key={id} id={id} />
            ))}
        </div>
    );
}

export default FoldersContainer;
